import React, { useEffect } from 'react';
const SuccessMessage = ({
  vehicleCategory,
  vehicleCategories = [],
  scrapValueText = '',
  scrapMessage = '',
  scrapSuccessMessage = '',
  scrapCongratulations = '',
  scrapCompletionIcon = '',
  vehicleTerm,
}) => {
  const getScrapRange = () => {
    const selectedCategory = vehicleCategories.find((cat) => cat.displayName === vehicleCategory);

    return selectedCategory?.fields?.Message?.value || '';
  };

  return (
    <div className="contact-form">
      <h3 className="valuation-heading">{scrapValueText}</h3>
      <div className="valuation-banner">
        {scrapMessage}
        <span className="valuation-amount">{getScrapRange()} </span>

        <span className="star-tooltip">
          *<span className="tooltip-text">{vehicleTerm}</span>
        </span>
      </div>

      <div className="completion-message">
        <div className="completion-title">{scrapCongratulations}</div>
        <div className="completion-icon">{scrapCompletionIcon}</div>
        <div className="completion-text">{scrapSuccessMessage}</div>
      </div>
    </div>
  );
};

export default SuccessMessage;
